// SETUP SELECT ELEMENTS
	var wrap_select_elements = function() {
		$(document).ready(function(){
			$('[data-browser-select-wrapper] select').each(function(){
				if( $(this).closest('.select-wrap').length == 0 ) {
					$(this).wrap('<div class="select-wrap"></div>');
					var value = $(this).val();
					if( ! value ) {
						if( $(this).find('option[selected]').length > 0 ) {
							value = $(this).find('option[selected]').attr('value');
						} else {
							value = $(this).find('option:eq(0)').attr('value');
						}
					}
					var placeholder = $(this).find('option[value="' + value + '"]').text();
					if( $(this).closest('.browser-field-wrapper').is('[data-selected-active]') ) {
						placeholder = 'Change Industry';
					}
					$(this).closest('.select-wrap').prepend('<div class="placeholder">' + placeholder + '</div>');
				};
			});
		});
	}
	
	wrap_select_elements();

// COLLAPSE STATES
	var filter_collapse_states = {
		'industry'		: false,
		'product_type'	: false
	};
	var get_set_filter_collapse_states = function(){
		var wwidth = window.outerWidth;
		$('[data-filter-name]').each(function(){
			if( typeof filter_collapse_states[$(this).attr('data-filter-name')] === 'undefined' ) {
				filter_collapse_states[$(this).attr('data-filter-name')] = wwidth >= 992 ? false : true;
			}
			if( filter_collapse_states[$(this).attr('data-filter-name')] ) {
				$(this).addClass('browser-field-wrapper--collapsed').find('.browser-field-content').hide()
			} else {
				$(this).removeClass('browser-field-wrapper--collapsed').find('.browser-field-content').show();
			}
		})
	}
	get_set_filter_collapse_states();


// BROWSE
var browse_areas = [];
var input_sliders = {};
var set_update_number_slider;
var set_update_number_sliders;

const BROWSE_INDUSTRY = $('.section--industry-product-type-browse').attr('data-industry-name');
const BROWSE_PRODUCT_TYPE = $('.section--industry-product-type-browse').attr('data-product_type-name');

// INSTRUCTIONS
var browse_instructions = {
	industryproduct_type	: 'Select your <strong>Industry</strong> and a <strong>Product Type</strong> to narrow results and show additional filters.',
	industry				: 'Select your <strong>Industry</strong> to narrow results and show additional filters.',
	product_type			: 'Select a <strong>Product Type</strong> to narrow results and show additional filters.',
};
var set_browse_instructions = function(){
	var $wrapper = $('.section--industry-product-type-browse');
	var type = '';
	if(
		! $wrapper.find('[data-filter-name="industry"] select').val() ||
		Number( $wrapper.find('[data-filter-name="industry"] select').val() ) == -1
	) {
		type += 'industry';
	}
	if(
		! $wrapper.find('[data-filter-name="product_type"] select').val() ||
		Number( $wrapper.find('[data-filter-name="product_type"] select').val() ) == -1
	) {
		type += 'product_type';
	}
	if( type ) {
		$('.browser-instruction').html( browse_instructions[type] ).show();;
	} else {
		$('.browser-instruction').html('').hide();;
	}
}

// RANGE SLIDER STEPS
	var precision_round = function( num, precision ){
		return Math.round( num / precision ) * precision;
	}

	Number.prototype.count_decimals = function () {
		if(Math.floor(this.valueOf()) === this.valueOf()) return 0;
		return this.toString().split(".")[1].length || 0; 
	}
	// STEPS FOR RANGE SLIDERS (MAX : STEP)	
	var slider_steps = {
		1		: .01,
		5		: .05,
		10		: .1,
		15		: .1,
		20		: .5,
		100		: 1,
		200		: 5,
		500		: 10,
		1000	: 20,
		2500	: 50,
		5000	: 100,
		10000	: 250
	}

	// GET THE STEP GIVEN A RANGE
	var get_step_interval = function( min, max, value ) {
		var difference = Math.abs( max - min );
		var return_val = false;
		var keys = Object.keys(slider_steps);
		keys.forEach(step_max => {
			if( return_val === false && parseFloat( step_max ) >= difference ) {
				return_val = slider_steps[step_max];
			}
		});
		if( return_val === false ) return_val = Object.values(slider_steps).pop();
		
		if( typeof limit !== 'undefined' ) {
			if( limit < return_val ) return_val = limit;
		}

		return return_val;
	}
	
	// RETURN ARRAY OF MIN, MAX, VALUE AND ALL STEPS IN BETWEEN (INTERVAL CALCULATED IN get_step_interval)
	var get_step_values_array = function( min, max, value ) {
		if( min > max ) {
			var temp_max = min;
			var temp_min = max;
			min = temp_min;
			max = temp_max;
		}
		
		var steps = get_step_interval( min, max, value );
		
		var values = [ min, max ];
		
		if( value ) {
			if( typeof value !== 'object' ) {
				values.push( value );
			} else {
				values = [ ...values, ...value ];
			}
		}
		
		var i = precision_round( min, steps );
		while( i < max ) {
			if( i > min && i < max ) {
				values.push(i)
			}
			i = round_decimal( i + steps );
		}
		filtered_values = values.filter(function( value, index, self ) { return self.indexOf(value) === index }).sort( function( a, b ){ return a - b });
		return filtered_values;
	}
	
	// IF VALUE IN SLIDER DOES NOT EXIST, ADD IT TO ARRAY & RESORT, AND RETURN POSITION OF VALUE IN ARRAY
	var get_set_arbitrary_slider_val = function( value, filter_name ) {
		var return_val = input_sliders[filter_name].steps.indexOf(Number(value));

		if( return_val === -1 ) {
			// UPDATE STEPS & SORT
			input_sliders[filter_name].steps.push( parseFloat( value ) );						
			input_sliders[filter_name].steps = input_sliders[filter_name].steps.filter(function( value, index, self ) { return self.indexOf(value) === index }).sort( function( a, b ){ return a - b });
			
			input_sliders[filter_name].elem.noUiSlider.updateOptions({
				range: {
					'min': 0,
					'max': input_sliders[filter_name].steps.length - 1
				}
			});
			return input_sliders[filter_name].steps.indexOf(Number(value));
		}
		
		return return_val;
	}


// OUTER LOOP FOR BROWSER (ONLY SHOULD HAPPEN ONCE, )
$('[data-browse-wrapper]').each(function(){
	var $this = $(this);
	
	// RANGE/NUMBER SLIDER UI
	set_update_number_slider = function( name ) {
		var $elem = $('[data-input-slider][name="' + name + '"]');
		
		// DESTROY EXISTING SLIDER
		if( typeof input_sliders[name] !== 'undefined' && typeof input_sliders[name].slider !== 'undefined' ) {
			input_sliders[name].slider.destroy();
		};
		
		// SET SETTINGS
		var is_range = $elem.is('[data-input-slider="range"]');
		var subtype = $elem.is('[data-input-slider-connect="1,0"]') ? 'max' : 'min';
		var connect = [];
		$.each( $elem.attr('data-input-slider-connect').split(','), function(key, value){
			connect.push( parseInt( value ) ? true : false );
		});
		if( connect.length == 1 ) connect = connect[0];
		var elem_id = $elem.attr('id');
		var $target = is_range ? $('[data-range-min][for="' + elem_id + '"]') : $('[data-number][for="' + elem_id + '"]');
		
		var data_min_start = get_converted_unit( $elem.attr('data-unit-convert'), $elem.attr('data-min-start') );
		var data_max_start = get_converted_unit( $elem.attr('data-unit-convert'), $elem.attr('data-max-start') );
		var data_min = get_converted_unit( $elem.attr('data-unit-convert'), $elem.attr('data-min') );
		var data_max = get_converted_unit( $elem.attr('data-unit-convert'), $elem.attr('data-max') );
		var data_start = get_converted_unit( $elem.attr('data-unit-convert'), $elem.attr('data-start') );

		if( is_range ) {
			var initial_start = data_min_start > data_max_start ? [ data_max_start, data_min_start ] : [ data_min_start, data_max_start ];
		} else {
			var initial_start = data_start;
		}

		// var steps = get_step_interval( data_min, data_max, ( is_range ? [ data_min_start, data_max_start ] : data_start ) );

		input_sliders[name] = {
			elem		: $elem[0],
			range		: is_range,
			subtype		: subtype,
			target		: $target,
			unit		: $target.attr('data-unit-convert'),
			round		: $target.is('[data-unit-round]') ? intval( $target.attr('data-unit-round') ) : 3,
			value		: false,
			base_value	: false,
			interacted	: $elem.attr('data-input-slider-engaged') == 'true' ? true : false,
			steps		: get_step_values_array( data_min, data_max, ( is_range ? [ data_min_start, data_max_start ] : data_start ) ),
		}
		
		// ALTERNATE CONFIGURATION WITH SET STEPS
			input_sliders[name].config = {
				start: initial_start,
				connect: connect,
				range: {
					'min': 0,
					'max': input_sliders[name].steps.length - 1
				},
				step	: 1,
				format	: {
					to: function(value) {
						return input_sliders[name].steps[Math.round(value)];
					},
					from: function (value) {
						return get_set_arbitrary_slider_val(value, name);
					}
				}
			};

		// CREATE SLIDER
		input_sliders[name].slider = noUiSlider.create( input_sliders[name].elem, input_sliders[name].config );

		// SLIDE
		input_sliders[name].elem.noUiSlider.on('slide', function() {
			var elem_id = $(this.target).attr('id');
			var input_slider = input_sliders[$('#' + elem_id).attr('name')];
			input_sliders[$('#' + elem_id).attr('name')].interacted = true;
		})

		// CHANGE
		input_sliders[name].elem.noUiSlider.on('change', function() {
			
			set_dataLayer({
				'event' 		: 'product finder filter',
				'filterName'	: name,
				'filterValue'	: input_sliders[name].value,
				'industry'		: BROWSE_INDUSTRY,
				'productType'	: BROWSE_PRODUCT_TYPE,
			});
			
			$this.attr('data-browse-offset', 0);
			$this.submit_browse_form();
		})

		// UPDATE
		input_sliders[name].elem.noUiSlider.on('update', function() {
			var elem_id = $(this.target).attr('id');
			var input_slider = input_sliders[$('#' + elem_id).attr('name')];
			var input_val = this.get();

			if( typeof input_val == 'object' ) {
				if( isNaN( input_val[0] ) ) return;
				var temp_val = [];
				var temp_val_base = [];
				$.each(input_val, function(key, value){
					temp_val.push( parseFloat( value ) );
					temp_val_base.push( get_reverse_converted_unit( input_slider.unit, parseFloat( value ) ) );
				})
				if( temp_val_base[0] > temp_val_base[1] ) temp_val_base = [ temp_val_base[1], temp_val_base[0] ];
				input_sliders[$('#' + elem_id).attr('name')].value = temp_val.join(',');
				input_sliders[$('#' + elem_id).attr('name')].base_value = temp_val_base.join(',');
			} else {
				if( isNaN( input_val ) ) return;
				input_sliders[$('#' + elem_id).attr('name')].value = parseFloat( input_val );
				input_sliders[$('#' + elem_id).attr('name')].base_value = get_reverse_converted_unit( input_slider.unit, parseFloat( input_val ) );
			}

			if( input_slider.range ) {
				var unit_min_converted = get_reverse_converted_unit( input_slider.unit, input_val[0], input_slider.round );
				var unit_max_converted = get_reverse_converted_unit( input_slider.unit, input_val[1], input_slider.round );
				
				$('[data-range-min][for="' + elem_id + '"]').attr('data-unit-base', unit_min_converted ).find('input').val( input_val[0].comma_number() );
				
				$('[data-range-max][for="' + elem_id + '"]').attr('data-unit-base', unit_max_converted ).find('input').val( input_val[1].comma_number() );
			} else {
				var unit_converted = get_reverse_converted_unit( input_slider.unit, input_val, input_slider.round );
				
				$('[data-number][for="' + elem_id + '"]').attr('data-unit-base', unit_converted ).find('input').val( input_val.comma_number() );
			}
		});

	}

	// FOCUS / SHOW NUMBER SETTER
	$this.on('click', '.range-input', function() {
		$(this).find('input[type="number"]').focus();
	});
	
	// KEYUP
	$this.on('keyup', '[data-converted-unit-number-set]', function(){
		if( $(this).val() != '.' && $(this).val() != $(this).val().comma_number() ) {
			$(this).val( $(this).val().comma_number() )
		}
	})
	
	// UPDATE & CONVERT NUMBER INPUT
	$this.on('change', '[data-converted-unit-number-set]', function(){
		var filter_name = $(this).closest('[data-filter-name]').attr('data-filter-name');
		var $range_input = $(this).closest('.range-input');
		var input_value = parseFloat( $(this).val().replace ( /[^0-9.]/g, '' ) );

		var max = get_converted_unit( input_sliders[filter_name].unit, parseFloat( $(this).attr('data-unit-base-max') ) );
		var min = get_converted_unit( input_sliders[filter_name].unit, parseFloat( $(this).attr('data-unit-base-min') ) );

		if( min > max ) {
			var temp_max = min;
			var temp_min = max;
			min = temp_min;
			max = temp_max;
		}

		if( $(this).val() > max ) {
			$(this).val(max);
		} else if( $(this).val() < min ) {
			$(this).val(min);
		}

		var set_value = $(this).val();

		var converted = Number( $(this).val().split(',').join('') );
		
		// $range_input.find('span').text( Number(set_value).comma_number() );
		$range_input.find('input').val( Number(set_value).comma_number() );
		
		if( input_sliders[filter_name] ) {
			input_sliders[filter_name].interacted = true;
			var current_values = input_sliders[filter_name].elem.noUiSlider.get();

			// ADD NEW ARBITRARY VALUES TO ARRAY IF THEY DO NOT EXIST ALREADY
			get_set_arbitrary_slider_val( converted, filter_name );

			if( $range_input.is('[data-range-min]') ) {
				input_sliders[filter_name].elem.noUiSlider.set( [ converted, current_values[1] ] );
			} else if( $range_input.is('[data-range-max]') ) {
				input_sliders[filter_name].elem.noUiSlider.set( [ current_values[0], converted ] );
			} else {
				input_sliders[filter_name].elem.noUiSlider.set( converted );
			}
			$this.submit_browse_form();
		}
	})

	// SET ALL SLIDERS
	set_update_number_sliders = function() {
		$this.find('[data-input-slider]').each(function(){
			set_update_number_slider( $(this).attr('name') );
		});
	}
	set_update_number_sliders();
	
	// FILTER SELECT
	$this.on('change', 'select:not([name="sort"],[data-units])', function(e){
		e.preventDefault();
		set_dataLayer({
			'event' 		: 'product finder filter',
			'filterName'	: $(this).attr('name'),
			'filterValue'	: $(this).find('option[value="' + $(this).val() + '"]').text(),
			'industry'		: BROWSE_INDUSTRY,
			'productType'	: BROWSE_PRODUCT_TYPE,
		});
		$this.attr('data-browse-offset', 0);
		$this.submit_browse_form();
	});
	
	// FILTER CHECKBOXES
	$this.on('change', 'input[type="checkbox"]', function(e){
		e.preventDefault();
		
		let selected = [];
		$this.find('[name="' + $(this).attr('name') + '"]:checked').each(function(){
			selected.push($(this).val());
		});
		
		if( selected ) {
			set_dataLayer({
				'event' 		: 'product finder filter',
				'filterName'	: $(this).attr('name'),
				'filterValue'	: selected.join(','),
				'industry'		: BROWSE_INDUSTRY,
				'productType'	: BROWSE_PRODUCT_TYPE,
			});
		}

		$this.attr('data-browse-offset', 0);
		$this.submit_browse_form();
	});
	
	// SEARCH (NOT ACTIVE)
	$this.on('submit', '[data-browse-search]', function(e){
		e.preventDefault();
		$this.attr('data-browse-offset', 0);
		$this.submit_browse_form();
	});
	
	// SWITCH FILTER (NOT ACTIVE)
	$this.on('click', '[data-switch-filter]', function(e){
		e.preventDefault();
		$this.attr('data-browse-display', $(this).attr('data-switch-filter'));
	});
	
	// READ MORE (NOT ACTIVE)
	$this.on('click', '[data-browse-read-more]', function(e){
		e.preventDefault();
		set_dataLayer({
			'event' 	: 'product finder load more',
			'action'	: 'click',
			'label'		: 'Load More'
		});
		$this.attr('data-browse-offset', parseInt( $this.attr('data-browse-offset') ) + parseInt( $this.attr('data-browse-count')));
		$this.submit_browse_form( true );
	});

	// LOAD MORE (OVERVIEW)
	$this.on('click', '[data-show-more]', function(e){
		e.preventDefault();
		$this.attr('data-offset', $this.find('.card--product:not(.card--product--featured)').length);
		$this.attr('data-offset-total', $this.find('.card--product').length);
		$this.attr('data-show-more', 1);
		$this.submit_browse_form();
		$this.attr('data-offset', 0);
		$this.attr('data-offset-total', 0);
	})
	
	// CLEAR FILTERS
	$this.on('click', '[data-clear-filters]', function(e){
		e.preventDefault();
		// UI REFRESHED
		$this.find('select').not('[data-redirect-select], [data-redirect], [data-units], [name="sort"]').each(function(){
			$(this).val('-1').closest('.select-wrap').find('.placeholder').html( $(this).find('option[value="' + $(this).val() + '"]').text() );
		});
		$this.find('input[type="checkbox"]').prop('checked', false);
		$.each(input_sliders, function(key, input_slider){
			input_sliders[key].interacted = false;
			// if( input_sliders[key].range ) {
			// 	input_sliders[key].slider.set([ input_sliders[key].config.range.min, input_sliders[key].config.range.max ]);
			// } else if( input_sliders[key].subtype == 'max' ) {
			// 	input_sliders[key].slider.set(input_sliders[key].config.range.max);
			// } else {
			// 	input_sliders[key].slider.set(input_sliders[key].config.range.min);
			// }
		});
		set_dataLayer({
			'event' 	: 'product finder clear filters',
			'action'	: 'click',
			'label'		: 'Clear Filters'
		});
		$this.submit_browse_form( false );
	});
	
	// SORT
	$this.on('change', '[name="sort"]', function(e){
		e.preventDefault();
		
		set_dataLayer({
			'event' 		: 'product finder sort',
			'sortValue'	: $(this).find('option[value="' + $(this).val() + '"]').text(),
			'industry'		: BROWSE_INDUSTRY,
			'productType'	: BROWSE_PRODUCT_TYPE,
		});
		
		$this.submit_browse_form( false );
	});
	
	// COLLAPSE FILTERS
	$this.on('click', '.browser-field-collapse', function(e){
		e.preventDefault();
		var $wrapper = $(this).closest('.browser-field-wrapper');
		if( $wrapper.is('.browser-field-wrapper--collapsed') ) {
			$wrapper.removeClass('browser-field-wrapper--collapsed').find('.browser-field-content').show();//.slideDown('slow');
			filter_collapse_states[$wrapper.attr('data-filter-name')] = false;
		} else {
			$wrapper.addClass('browser-field-wrapper--collapsed').find('.browser-field-content').hide();//.slideUp('slow');
			filter_collapse_states[$wrapper.attr('data-filter-name')] = true;
		}
	})
});


$.fn.submit_browse_form = function(read_more) {
	read_more = ! read_more ? 0 : 1;

	var $this = $(this);

	var url = $this.attr('data-browse-base-url');
	var url_segments = [];
	var has_filters = 0;

	var ajax_data = {
		lang			: $this.attr('data-browse-lang'),
		action			: $this.attr('data-browse-action'),
		count			: $this.attr('data-browse-count'),
		post_id			: $this.attr('data-post-id'),
		overview		: $this.attr('data-overview'),
		return_type		: 'json',
		filters			: {},
		offset			: $this.attr('data-offset'),
		offset_total	: $this.attr('data-offset-total'),
		show_more		: $this.attr('data-show-more')
	};
	
	if( $this.attr('data-default-industry') && Number( $this.attr('data-default-industry') ) != 0 ) {
		ajax_data.filters['industry'] = $this.attr('data-default-industry');
	}
	if( $this.attr('data-default-product_type') && Number( $this.attr('data-default-product_type') ) != 0 ) {
		ajax_data.filters.product_type = $this.attr('data-default-product_type');
	}
	
	// SELECT DROPDOWNS
	$this.find('select').not('[data-units],[name="sort"]').each(function(){
		if(
			$(this).val() != -1 && 
			$(this).val() != null &&
			! ( $(this).attr('name') == 'industry' && BROWSE_INDUSTRY ) &&
			! ( $(this).attr('name') == 'product_type' && BROWSE_PRODUCT_TYPE )
		) {
			ajax_data.filters[$(this).attr('name')] = $(this).val();
			ajax_data[$(this).attr('name')] = $(this).val();
			url_segments.push( 'filters[' + $(this).attr('name') + ']=' + $(this).val() );
			has_filters = 1;
		};
	});
	
	// INPUT SLIDERS
	$.each(input_sliders, function(key, input_slider){
		// UNSET SLIDER FILTER ACTIVE STATE IF SET VALUES ARE MIN AND MAX
		if( input_sliders[key].interacted && input_sliders[key].range == true ) {

			value = input_sliders[key].value.split(',');
			if( parseFloat( value[0] ) == input_sliders[key].steps[0] && parseFloat( value[1] ) == input_sliders[key].steps[input_sliders[key].steps.length - 1] ) {
				input_sliders[key].interacted = 0;
			}
			
			var converted_value = [];
			$.each(input_sliders[key].value.split(','), function(k, v){
				converted_value.push( get_reverse_converted_unit( input_sliders[key].unit, v ) );
			})
			
			if( converted_value.length == 2 && converted_value[0] > converted_value[1] ) {
				converted_value = [ converted_value[1], converted_value[0] ];
			}
			
			converted_value = converted_value.join(',');
		} else if( input_sliders[key].interacted ) {
			var converted_value = get_reverse_converted_unit( input_sliders[key].unit, input_sliders[key].value );
		}

		if( input_sliders[key].interacted ) {
			ajax_data.filters[key] = converted_value;
			url_segments.push( 'filters[' + key + ']=' + ajax_data.filters[key] );
			has_filters = 1;
		}
	});
	
	// CHECKBOXES
	$this.find('input[type="checkbox"]:checked').each(function(){
		if( ! ajax_data.filters[$(this).attr('name')] ) ajax_data.filters[$(this).attr('name')] = [];
		ajax_data.filters[$(this).attr('name')].push($(this).val());
		url_segments.push( 'filters[' + $(this).attr('name') + '][]=' + encodeURIComponent( $(this).val() ) );
		has_filters = 1;
	});
	
	// SORT
	if( $this.find('[name="sort"]').val() != '-1' ) {
		ajax_data.sort = $this.find('[name="sort"]').val();
		url_segments.push( 'sort=' + $this.find('[name="sort"]').val() );
	}
	
	// DEBUG - SHOW VALUES
	if( $this.is('[data-show-browser-values]') ) {
		ajax_data['show-browser-values'] = 1;
		url_segments.push( 'show-browser-values=1' );
	}

	console.log('sending ajax data...', ajax_data);
	$this.attr('data-browse-status', 'loading');

	$.ajax({
		url		: '/wp-admin/admin-ajax.php',
		type	: 'GET',
		data	: ajax_data,
		success	: function(result){
			if( result ) {
				result = JSON.parse( result );
				console.log('browse result:', result);

				var is_show_more = typeof result.show_more != 'undefined' && result.show_more ? 1 : 0;

				// UNSET OFFSET
				$this.attr('data-offset', 0);
				$this.attr('data-offset-total', 0);

				// REDIRECT IF THIS IS SET
				if( result.redirect ) {
					window.location.href = result.redirect;
					return false;
				}
				
				// READ MORE HANDLING
				if( is_show_more ) {
					$this.attr('data-browse-status', '').find('[data-browse-content]').append(result.html);
				} else {
					$this.attr('data-browse-status', '').find('[data-browse-content]').html(result.html);

					// UPDATE COUNT OF PRODUCTS FOUND
					$('[data-browse-result-count]').html( '<strong>' + result.count + '</strong> Product' + ( result.count != 1 ? 's' : '' ) + ' Found' );
				}

				if( $this.find('.card--product').length >= result.count ) {
					$('[data-show-more-wrapper]').addClass('d-none');
				} else {
					$('[data-show-more-wrapper]').removeClass('d-none');
				}
				
				// NO RESULTS
				if( result.count == 0 ) {
					$this.attr('data-browse-status', 'no-results');
				}
				
				if( ! is_show_more ) {
					// REMOVE & RERENDER FILTERS
					$('.browser-field-wrapper').not('[data-filter-name="industry"],[data-filter-name="product_type"]').remove();
					$.each(result.filters, function(key, filter) {
						if( filter.name == 'industry' && filter.rendered ) {
							$('.browser-field-wrapper[data-filter-name="industry"]').replaceWith(filter.rendered);
						} else if( filter.name == 'product_type' && filter.rendered ) {
							$('.browser-field-wrapper[data-filter-name="product_type"]').replaceWith(filter.rendered);
						} else {
							$('.browser-area-field-wrapper').append(filter.rendered);
						}
					});

					wrap_select_elements();
					update_all_units();
					get_set_filter_collapse_states();
					set_update_number_sliders();
					set_browse_instructions();
				}

				
				
				// LAZY ELEMENT UPDATE
				get_new_lazy_elems();
				$(document).trigger('scroll');
				setTimeout(function(){
					$(window).trigger('resize');
					if( ! is_show_more ) {
						// SCROLL TO CONTENT
						smooth_scroll( $('.browse-area--content') );
					}
				}, 50);

			} else {
				$this.attr('data-browse-status', 'no-results');
			}
			if( url_segments.length > 0 ) {
				url += '?' + url_segments.join('&');
			}
			$this.attr('data-has-filters', has_filters);
			window.history.pushState( '', '', url );
		}
	})
}


// AUTOSUBMIT WHEN INDUSTRY IS KNOWN BUT NOT AUTO SET, EXCEPT WHEN PREVENTED
$('[data-browse-wrapper]').each(function(){
	$this = $(this);
	if(
		$this.find('[name="industry"]').val() &&
		Number( $this.find('[name="industry"]').val() ) == -1 &&
		! $this.is('[data-prevent-autoload]') &&
		user_data.industry && 
		user_data.industry.id
	) {
		$this.find('[name="industry"]').val(user_data.industry.id);
		$(this).submit_browse_form();
	}
	set_browse_instructions();
})
